<template>
  <div style="padding: 10px">
      <el-row style="margin-bottom: 20px;" >
        <el-col :span="8">
          <el-select v-model="formData.fromStoreId" class="form-item" placeholder="退料个人库" clearable>
            <el-option v-for="item in myStoreList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select v-model="formData.toStoreId" class="form-item" placeholder="退回目的总库" clearable>
            <el-option v-for="item in storeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-button @click="addMaterial(1)">添加物料行</el-button>
        </el-col>
      </el-row>

      <el-row class="box">
        <el-col :span="15">物料名称</el-col>
        <el-col :span="4">个人库数量</el-col>
        <el-col :span="4">退料数量</el-col>
        <el-col :span="1"></el-col>
      </el-row>

      <div style="height:290px;overflow-y: auto;overflow-x: hidden">
        <el-row v-for="item in formData.itemList" :key="item.id" class="row" :gutter="15">
          <el-col :span="16">
            <el-select v-model="item.id" placeholder="选择物料" style="width: 100%" clearable filterable @change="onMaterialChange(item)">
              <el-option v-for="material in materialAll" :key="material.id" :label="material.name" :value="material.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" >
            <el-input v-model="item.stock" placeholder="个人库数量" readonly style="width: 100%"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input v-model="item.cnt" placeholder="退料数量" style="width: 100%"></el-input>
          </el-col>
          <el-col :span="1">
            <div class="close" @click="removeOneMaterial(item.nanoid)">
              <el-icon>
                <ElIconClose></ElIconClose>
              </el-icon>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-row style="margin-top: 15px">
        <el-col :span="24">
          <el-input type="textarea" class="quote-remark" v-model="formData.remark" placeholder="备注" style="width: 100%" :autosize="true"></el-input>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button type="primary" style="width: 500px;;margin-top: 20px" @click="createRequest" :loading="loading">提交申请</el-button>
      </el-form-item>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'
export default {
  name: "CreateReturnRequest",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        fromStoreId: '',
        toStoreId: '',
        remark:'',
        itemList: []
      },
      storeList:[],
      myStoreList:[],
      materialAll:[],
      loading: false
    }
  },
  computed: {
  },
  created() {
    this.getStoreList()
    this.getMyStoreList()
    this.getMaterialAll()
    this.addMaterial(5)
  },
  methods: {
    getStoreList(){
      this.$axios.get('wms/store/getStoreList?personal=false&sameCity=true').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取仓库列表失败");
        }

        this.storeList = res.data;
      }, error => {
        this.$message.error(`获取失败，${error.message}`);
      })
    },
    getMyStoreList(){
      this.$axios.get('wms/store/getMyStoreList').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取仓库列表失败");
        }

        this.myStoreList = res.data;
      }, error => {
        this.$message.error(`获取失败，${error.message}`);
      })
    },
    getMaterialAll(){
      this.$axios.get('wms/material/getAll').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取物料列表失败");
        }

        this.materialAll = res.data;
      }, error => {
        this.$message.error(`获取失败，${error.message}`);
      })
    },
    onMaterialChange(item){
      if(this.formData.fromStoreId == ''){
        return this.$message.error("未选择个人库");
      }

      if(item.id == ''){
        item.stock = 0;
        item.cnt = 0;
        return;
      }

      var url = 'wms/materialStock/getMaterialStock?materialId=' + item.id + '&storeId=' + this.formData.fromStoreId
      this.$axios.get(url).then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取物料库存失败");
        }

        item.stock = res.data;
      }, error => {
        this.$message.error(`获取失败，${error.message}`);
      })

    },
    getItemLabel(item){
      return item.name + '(' + item.code + ')';
    },
    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()
    },
    clearPreData() {
      //清空表单数据
      this.formData.itemList = []
      this.addMaterial(5);
    },
    createRequest() {

      if(this.formData.storeId == ''){
        return this.$message.error("未选择仓库");
      }

      var a = 0;
      for (let i = 0; i < this.formData.itemList.length; i++) {
        let obj = this.formData.itemList[i]
        if (obj.id) {

            if (!obj.cnt) {
              return this.$message.error(`第${i + 1}行数量不能为空`);
            }

            if (obj.cnt > obj.stock) {
              return this.$message.error(`第${i + 1}行退料数量不能超过库存数量`);
            }

            a++;
            obj.has_data = true;
        }
      }

      if (a == 0) {
        return this.$message.error("退料数据不能为空");
      }

      this.loading = true;
      this.$axios.post('wms/request/return/create', this.formData).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code != 0) {
          return this.$message.error(`提交失败，${res.message}`);
        }

        this.$message.success("提交成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.clearPreData();
      }, error => {
        this.loading = false;
        this.$message.error(`提交失败，${error.message}`);
      })
    },
    addMaterial(cnt) {
      for (let i = 0; i < cnt; i++) {
        this.formData.itemList.push({
          nanoid: nanoid(),
          productDetails: {}
        })
      }
    },
    removeOneMaterial(nanoid) {
      let index = this.formData.itemList.findIndex(item => item.nanoid === nanoid);
      this.formData.itemList.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>